import React from "react";
import "./CustomSoftware.css";
import SEO from "../../SEO";
// Example data for the software services
const softwareServices = [
  {
    title: "Desktop Applications",
    description:
      "We specialize in C# Windows Forms (WinForms) and WPF for creating intuitive, high-performance desktop applications. Perfect for ERP, inventory, and custom business tools.",
    features: [
      "C# WinForms",
      "WPF",
      "ERP & Inventory Systems",
      "Custom Business Tools",
    ],
    img: process.env.PUBLIC_URL + "/img/software-development.gif", // Replace with your own image
    icon: "bi-pc-display",
  },
  {
    title: "Web Applications",
    description:
      "ASP.NET MVC, ASP.NET Core MVC, React.js, and Vue.js to build scalable, secure, and dynamic web applications with REST APIs and real-time data.",
    features: [
      "ASP.NET MVC",
      "ASP.NET Core",
      "React.js",
      "Vue.js",
      "REST APIs",
    ],
    img: process.env.PUBLIC_URL + "/img/Website-Design-Services.gif",
    icon: "bi-globe",
  },
  {
    title: "Cross-Platform Apps",
    description:
      "Electron.js allows building cross-platform desktop applications that run on Windows, macOS, and Linux with a single codebase, ideal for productivity and communication tools.",
    features: [
      "Electron.js",
      "Cross-Platform",
      "Single Codebase",
      "Productivity Tools",
    ],
    img: process.env.PUBLIC_URL + "/img/CrossPlateForm.gif",
    icon: "bi-laptop",
  },
  {
    title: "Full-Stack Solutions",
    description:
      "Server-side programming with C# & ASP.NET combined with front-end frameworks like React.js and Vue.js for scalable, maintainable, and high-performance solutions.",
    features: [
      "C# & ASP.NET",
      "React.js",
      "Vue.js",
      "Database Integration",
      "Cloud Services",
    ],
    img: process.env.PUBLIC_URL + "/img/FullStack.gif",
    icon: "bi-code-slash",
  },
  {
    title: "Mobile Applications",
    description:
      "We develop high-performance mobile applications for Android and iOS using modern frameworks. Our solutions include native development with C# via Xamarin/.NET MAUI, and cross-platform apps using React Native. We focus on responsive UI, smooth performance, and seamless integration with backend systems.",
    features: [
      "Xamarin / .NET MAUI",
      "React Native",
      "iOS & Android",
      "API Integration",
      "Push Notifications",
      "Cross-Platform Deployment",
    ],
    img: process.env.PUBLIC_URL + "/img/mobilegif.gif",
    icon: "bi-phone",
  },
];

function CustomSoftware() {
  return (
    <>
      <SEO
        title="Custom Software Development – MZR Software"
        description="Tailored software solutions to fit your business needs. Scalable, reliable, and fully custom."
        image="https://mzrsoftware.com/assets/images/og-customsoftware.jpg"
        url="https://mzrsoftware.com/OurServices/CustomSoftware/customsoftware"
      />

      <div className="custom-software-page">
        {/* Services Section */}
        <section className="services-section">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">
                Our <span className="highlight">Custom Software</span>
              </h2>
              <p className="section-subtitle">
                Tailored software for Desktop, Web, and Cross-Platform
                applications to enhance productivity and efficiency.
              </p>
            </div>

            <div className="services-grid">
              {softwareServices.map((service, index) => (
                <div
                  key={index}
                  className={`service-card zig-zag ${
                    index % 2 === 0 ? "left" : "right"
                  }`}
                >
                  {/* Content Section */}
                  <div className="card-content">
                    <span className={`bi ${service.icon} service-icon`}></span>
                    <h3>{service.title}</h3>
                    <p>{service.description}</p>
                    <div className="service-features">
                      {service.features.map((feature, i) => (
                        <span key={i} className="feature-tag">
                          {feature}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Image Section */}
                  <div className="card-image">
                    <img src={service.img} alt={service.title} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default CustomSoftware;
